import { useState } from 'react'
import { usePermissions } from 'react-admin'
import { FlexBox } from 'shared/components/Base/Base'
import { CopyToClipBoard } from 'shared/components/CopyToClipBoard/CopyToClipBoard'
import { StyledDrawer } from 'shared/components/Sidebar/Sidebar.styles'
import { Text } from 'shared/components/Text/Text'
import { ProfilePageTab } from 'shared/pages/ProfilePage/ProfilePage'
import { royalBlue } from 'shared/theme/colors'

import { CtOnCtProfilePage } from '../Users/UserCtonCtProfile'
import { SIDEBAR_WIDTH } from './Sidebar.constants'

interface Props {
  children: React.ReactNode
  userId: string
  initialTab?: ProfilePageTab
}

export function UserSidebar({ userId, children, initialTab }: Props) {
  const { permissions } = usePermissions()
  const [isOpen, setIsOpen] = useState(false)
  const userLink = `/users/${userId}/show`

  return (
    <div data-test-id="user-sidebar">
      <div
        onAuxClick={(e) => {
          if (e.button === 1) return window.open(userLink, '_blank')
        }}
        onClick={(e) => {
          if (e.metaKey || e.ctrlKey) return window.open(userLink, '_blank')

          return setIsOpen(true)
        }}
      >
        {children}
      </div>
      <StyledDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        width={SIDEBAR_WIDTH}
        openLinkAddress={userLink}
        withOverlay
        header={
          <FlexBox justifyContent="flex-end" alignItems="center" isFullWidth mr={3}>
            <CopyToClipBoard text={userId} textProps={{ variant: 'header4' }}>
              <Text variant="header4" fontColor={royalBlue}>
                User ID - {userId.slice(0, 8)}...
              </Text>
            </CopyToClipBoard>
          </FlexBox>
        }
      >
        {() => (
          <CtOnCtProfilePage
            userId={userId}
            permissions={permissions}
            isInsideSidebar
            initialTab={initialTab}
          />
        )}
      </StyledDrawer>
    </div>
  )
}
